import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';
import classes from './FinalBannerAfterNotAdvanced.module.css';

const FinalBannerAfterNotAdvanced = () => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitle} colorBackground="#D4D4D4">
      <div className={classes.bannerWrapper}>
        <div className={classes.bannerBottomContent}>
          <div className={classes.bannerBottomContentTitle}>
            <p className={classes.yourSchool}>{texts.yourSchoolNotAdvanced}</p>
            <p className={classes.thesAreTheFinalists}>{texts.thesAreTheFinalistsNotAdvanced}</p>
          </div>
        </div>
      </div>
    </BannerTopComponent>
  );
};

export default FinalBannerAfterNotAdvanced;
